var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "entry_details" },
    [
      _c(
        "div",
        { staticClass: "entry_details_topbar" },
        [
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-arrow-left", size: "small" },
              on: { click: _vm.goBack }
            },
            [_vm._v("Back to Entries")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "entry_details_actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-printer", size: "small" },
                  on: { click: _vm.printEntry }
                },
                [_vm._v("Print")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    icon: "el-icon-delete",
                    size: "small"
                  },
                  on: { click: _vm.confirmDelete }
                },
                [_vm._v("Delete Entry")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.metadata
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 16 } }, [
                _c("div", { staticClass: "contactum_card" }, [
                  _c("div", { staticClass: "contactum_card_head" }, [
                    _c("div", { staticClass: "entry_info_box_title" }, [
                      _vm._v("Entry Details")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contactum_card_body" }, [
                    _c(
                      "table",
                      { staticClass: "form-table" },
                      _vm._l(_vm.fields, function(field, index) {
                        return _c(
                          "tr",
                          { key: index, staticClass: "contactum_table_row" },
                          [
                            _c("td", { staticClass: "form-title" }, [
                              _vm._v(_vm._s(field.label))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              Array.isArray(field.value)
                                ? _c("span", { staticClass: "form-value" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(field.value.join(" | ")) +
                                        "\n                "
                                    )
                                  ])
                                : _c("span", { staticClass: "form-value" }, [
                                    _vm._v(_vm._s(field.value))
                                  ])
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "contactum_card" }, [
                  _c("div", { staticClass: "contactum_card_head" }, [
                    _c("div", { staticClass: "entry_info_box_title" }, [
                      _vm._v("Submission Info")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contactum_card_body" }, [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "contactum-forms-entry-details-meta contactum_list_border_bottom"
                      },
                      [
                        _c("li", { staticClass: "contactum-forms-entry-id" }, [
                          _c("span", { staticClass: "lead-title" }, [
                            _vm._v("Entry ID:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "lead-text" }, [
                            _c("strong", [_vm._v(_vm._s(_vm.metadata.id))])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "contactum-forms-entry-date" },
                          [
                            _c("span", { staticClass: "lead-title" }, [
                              _vm._v("Submitted:")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "lead-text" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.metadata.created))
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "contactum-forms-entry-user" },
                          [
                            _c("span", { staticClass: "lead-title" }, [
                              _vm._v("User:")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "lead-text" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.metadata.user || "Guest"))
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "contactum-forms-entry-ip" }, [
                          _c("span", { staticClass: "lead-title" }, [
                            _vm._v("User IP:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "lead-text" }, [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.metadata.ip_address))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "contactum-forms-entry-referer" },
                          [
                            _c("span", { staticClass: "lead-title" }, [
                              _vm._v("Referer:")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "lead-text" }, [
                              _c("strong", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.metadata.referer,
                                      target: "_blank",
                                      rel: "noopener"
                                    }
                                  },
                                  [_vm._v("View")]
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "entry_loading" },
            [_c("el-skeleton", { attrs: { rows: 6, animated: "" } })],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }